import { useEffect } from 'react';
export function useScrollToAnchor() {
    useEffect(() => {
        requestAnimationFrame(() => {
            if (window.location.hash) {
                const hashElement = document.getElementById(window.location.hash.substring(1));
                if (hashElement) {
                    hashElement.scrollIntoView();
                }
            }
        });
    }, []);
}
